export enum RestaurantStatuses {
  operational = 'fullyOperational',
  preOperational = 'preOperational',
  temporarilyClosed = 'temporarilyClosed'
}
